import { render } from "./BlockList.vue?vue&type=template&id=4a844086"
import script from "./BlockList.vue?vue&type=script&lang=js"
export * from "./BlockList.vue?vue&type=script&lang=js"
script.render = render

export default script